export enum ErrorType {
	'NETWORK_ERROR' = 'NETWORK_ERROR',
	'CHUNK_ERROR' = 'CHUNK_ERROR',
	'NO_INTERNET_ERROR' = 'NO_INTERNET_ERROR',
}
